/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-12-03 15:35:19
 * @modify date 2021-12-03 15:35:19
 * @desc API 格式 https://{domain}/api/{app-name}/{service-name}/{service-uri}
 */
import { Utils } from '../helpers';
import { EnumApiAccountsvr } from './accountsvr';
import { EnumApiBffsvr } from './bffsvr';
import { EnumApiBusiness } from './business';
import { EnumApiCert } from './cert';
import { EnumApiCodetable } from './codetable';
import { EnumApiCompany } from './company';
import { EnumApiComsvr } from './comsvr';
import { EnumApiContent } from './content';
import { EnumApiIdass } from './idass';
import { EnumApiIntegral } from './Integral';
import { EnumApiLegal } from './legal';
import { EnumApiLicense } from './license';
import { EnumApiMicroapi } from './microapi';
import { EnumApiOrders } from './orders';
import { EnumApiOutagesNotice } from './outagesNotice';
import { EnumApiPartner } from './partner';
import { EnumApiPersonalCenter } from './personalCenter';
import { EnumApiPointsOrders } from './pointsOrder';
import { EnumApiPolymerization } from './polymerization';
import { EnumApiProduct } from './product';
import { EnumApiSecOrders } from './secOrders';
import { EnumApiShareLink } from './sharelink';
import { EnumApiThirdOrders } from './thirdOrders';
import { EnumApiUsersvr } from './usersvr';
import { EnumApiWechat } from './wechat';
import { EnumApiXiaozhi } from './xiaozhi';

export const EnumAPI = {
  ...new EnumApiBffsvr(),
  ...new EnumApiProduct(),
  ...new EnumApiContent(),
  ...new EnumApiUsersvr(),
  ...new EnumApiOrders(),
  ...new EnumApiPointsOrders(),
  ...new EnumApiWechat(),
  ...new EnumApiComsvr(),
  ...new EnumApiBusiness(),
  ...new EnumApiIntegral(),
  ...new EnumApiCert(),
  ...new EnumApiAccountsvr(),
  ...new EnumApiPartner(),
  ...new EnumApiCompany(),
  ...new EnumApiCodetable(),
  ...new EnumApiMicroapi(),
  ...new EnumApiIdass(),
  ...new EnumApiLicense(),
  ...new EnumApiPolymerization(),
  ...new EnumApiXiaozhi(),
  ...new EnumApiShareLink(),
  ...new EnumApiOutagesNotice(),
  ...new EnumApiThirdOrders(),
  ...new EnumApiPersonalCenter(),
  ...new EnumApiSecOrders(),
  ...new EnumApiLegal(),
};
Utils.toReadonly(EnumAPI);
